module.exports = ".headerDiv {\n  width: 96%;\n  margin-left: 59px;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 0; }\n\n.sideBarDiv {\n  position: relative;\n  z-index: 2;\n  height: 70px; }\n\n.sideBarContent {\n  position: absolute;\n  right: 0;\n  width: 100%;\n  padding: 20px; }\n\n.main-content {\n  min-height: 100% !important; }\n\n.page-section {\n  padding-top: 10px;\n  width: 100%;\n  float: left; }\n\n.page-section-bg {\n  padding-top: 10px;\n  width: 100%;\n  float: left;\n  background: #a0a1a0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shell/shell.component.scss
// module id = ./src/app/shell/shell.component.scss
// module chunks = main